import React, { Component, Fragment } from 'react';

import { I18n } from 'components/translate';
import { inject, observer } from 'mobx-react';
import { DataHubPlayerService } from 'modules/app/services/datahub/player';

import PlayerModal from './PlayerModal';

import ConfigService from '../../configManager/ConfigService';

@inject(({ UserStore }) => ({
  marketplaceId: UserStore.marketplaceId
}))
@observer
export default class PlayerBanner extends Component {
  constructor() {
    super();

    this.state = {
      activePlayerModalIsOpen: false,
      addOnCost: '',
      bundleAddOnCost: ''
    };
  }

  closeActivePlayerModal = () => {
    this.setState({
      activePlayerModalIsOpen: false
    });

    DataHubPlayerService.cancelPlayerDeactivationOnContentPageEvent();
  };

  componentDidMount() {
    const fetchCostData = async () => {
      const addOnCost =
        await ConfigService.getStreamingCostConsideringStreamingCampaign();

      this.setState({
        addOnCost
      });
    };

    fetchCostData();
  }

  openActivePlayerModal = async () => {
    const bundleAddOnCost = await ConfigService.getBundleStreamingCosts();

    this.setState({
      activePlayerModalIsOpen: true,
      bundleAddOnCost
    });

    DataHubPlayerService.openActivatePlayerModalEvent();
  };

  confirmAddOn = ({ confirmed: status }) => {
    ConfigService.updateStreamingStatus({ active: status });
  };

  render() {
    const { activePlayerModalIsOpen, addOnCost, bundleAddOnCost } = this.state;
    return (
      <Fragment>
        {false && (
          <label className="or__label">
            <I18n label="general.or" />
          </label>
        )}

        <div className="media__player__banner__wrapper">
          <div
            className="media__player__banner"
            onClick={() => this.openActivePlayerModal()}
          >
            <div className="media__icon">
              <div className="media__play">
                <i className="icon icon-play"></i>
              </div>
            </div>
            <div className="media__text">
              <div className="media__text__title">
                <I18n label="embed.banner.title" />
                <strong>
                  <I18n label="general.hotmart_player" />
                </strong>
              </div>
              <div className="media__text__description">
                <I18n label="embed.banner.description" />
              </div>
            </div>
          </div>
        </div>
        {activePlayerModalIsOpen && (
          <PlayerModal
            addOnCost={addOnCost}
            bundleAddOnCost={bundleAddOnCost}
            onConfirm={this.confirmAddOn}
            onClose={this.closeActivePlayerModal}
          />
        )}
      </Fragment>
    );
  }
}
